var BasePlugin = /** @class */ (function () {
    function BasePlugin(_a) {
        var pluginName = _a.pluginName, dataLayer = _a.dataLayer, _b = _a.logger, logger = _b === void 0 ? console : _b;
        this.logger = logger;
        this.dataLayer = dataLayer;
        this.pluginName = pluginName;
    }
    BasePlugin.prototype.init = function (config) {
        this.logger.log("Initializing ".concat(this.pluginName, " with configuration: ").concat(JSON.stringify(config || {})));
        this.config = config || {};
    };
    BasePlugin.prototype.destroy = function () {
        this.logger.log("Destroying ".concat(this.pluginName));
    };
    /**
     * pushes the data to the injected dataLayer instance.
     *
     * @param {DataLayerLibrary.JSONObject} data
     * @memberof BasePlugin
     */
    BasePlugin.prototype.pushEventToDataLayer = function (data) {
        this.dataLayer.pushEvent(data);
    };
    return BasePlugin;
}());
export default BasePlugin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wbHVnaW5zL2Jhc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7SUFNRSxvQkFBWSxFQUErRDtZQUE3RCxVQUFVLGdCQUFBLEVBQUUsU0FBUyxlQUFBLEVBQUUsY0FBZ0IsRUFBaEIsTUFBTSxtQkFBRyxPQUFPLEtBQUE7UUFDbkQsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7UUFDckIsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7UUFDM0IsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7SUFDL0IsQ0FBQztJQUVELHlCQUFJLEdBQUosVUFBSyxNQUFVO1FBQ2IsSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsdUJBQWdCLElBQUksQ0FBQyxVQUFVLGtDQUF3QixJQUFJLENBQUMsU0FBUyxDQUFDLE1BQU0sSUFBSSxFQUFFLENBQUMsQ0FBRSxDQUFDLENBQUM7UUFDdkcsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLElBQUssRUFBUSxDQUFDO0lBQ3BDLENBQUM7SUFFRCw0QkFBTyxHQUFQO1FBQ0UsSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMscUJBQWMsSUFBSSxDQUFDLFVBQVUsQ0FBRSxDQUFDLENBQUM7SUFDbkQsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0gseUNBQW9CLEdBQXBCLFVBQXFCLElBQWlDO1FBQ3BELElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2pDLENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUE5QkQsSUE4QkM7QUFFRCxlQUFlLFVBQVUsQ0FBQyJ9